import React from 'react';

import { useStoreReferralActivityQuery } from 'generated/graphql';



export interface IData {
  orderId: string;
}

export function useQuery({
  orderNumber, email
}: {
  orderNumber: string;
  email: string;
}) {
  const tuple = useStoreReferralActivityQuery({
    variables: {
      orderNumber,
      email
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        orderId: tuple.data?.orderLite?.id ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
